import axios from 'axios';

/**
 * Create an Axios Client with defaults
 */

const options = {
    baseURL: process.env.REACT_APP_APIURL
};

const client = axios.create(options);



// Add a request interceptor
client.interceptors.request.use(function (config) {
    // Do something before request is sent
    config.headers.Authorization = `Bearer 9931ac3afb88d233d4`
    return config;
}, function (error) {
    console.log(error);
    // Do something with request error
    return Promise.reject(error);
});


export default client;
